import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const SharesLineChart = ({sharesLineChart}) => {
    // Transform the data from sharesLineChart to the required format
    const data = sharesLineChart?.map(item => ({
      month: item?.label,
      value: item?.count,
    }));
  return (
    <ResponsiveContainer>
      <LineChart
        width={650}
        height={280}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="month" axisLine={{ stroke: "#000000" }} />
        <YAxis axisLine={{ stroke: "#000000" }} />
        <Tooltip />
        <Legend />
        <Line
          type="linear"
          name="Shares"
          dataKey="value"
          stroke="#005C53"
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SharesLineChart;
